import React, { useState, useEffect } from 'react';
import './Recorrido.scss'
import View360 from '../View360/View360';
import { useTranslation } from 'react-i18next';

const Recorrido = () => {
  const { t } = useTranslation();
  const [idScene, setId] = useState("acceso");
  const [yaw, setyaw] = useState(50);
  const [pitch, setpitch] = useState(0);

  const handleImagen = (tipo) =>{
    const removeElement = document.getElementsByClassName("active");
    removeElement[0].classList.remove("active")
    const element = document.getElementById(tipo);
    element.classList.add("active");
    if(tipo==="acceso"){
      setId("acceso");
      setyaw(50);
      setpitch(0);
    }else if(tipo==="lago"){
      setyaw(-30);
      setpitch(0);
      setId("lago");
    }else if(tipo==="alberca"){
      setId("alberca");
      setyaw(-90);
      setpitch(0);
    }
  }

  return ( 
    <div className='contenedor_recorrido'>
      {idScene ==="acceso" && (
        <View360 yaw={yaw} pitch={pitch} urlImagen="/assets/360/1.acceso.jpg" idScene="acceso" />
      )}
      {idScene ==="lago" && (
        <View360 yaw={yaw} pitch={pitch} urlImagen="/assets/360/2.lago.jpg" idScene="lago" />
      )}
      {idScene ==="alberca" && (
        <View360 yaw={yaw} pitch={pitch} urlImagen="/assets/360/3.alberca.jpg" idScene="alberca" />
      )}
      <span className='disclamer'>{t('recorrido.disclaimer')}</span>
      <div className='options'>
        <button id="acceso" className="active" onClick={()=>{handleImagen("acceso")}}>
          {t('recorrido.access')}
        </button>
        <button id="lago" onClick={()=>{handleImagen("lago")}}>
          {t('recorrido.lake')}
        </button>
        <button id="alberca" onClick={()=>{handleImagen("alberca")}}>
          {t('recorrido.pool')}
        </button>
      </div>
    </div>
  );
}

export default Recorrido;
